import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ApexOptions } from 'ng-apexcharts';

@Component({
    selector: 'category-cards',
    templateUrl: './category-cards.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatIconModule, CommonModule],
})
export class AnnouncementCard1 implements OnInit {
    @Input() title: string = '';
    @Input() value: number = 0;
    @Input() week: boolean = false;

    @Input() icon: string = 'mat_solid:help_outline';
    @Input() color: string = 'gray';

    chartVisitors: ApexOptions;
    chartConversions: ApexOptions;
    chartImpressions: ApexOptions;
    chartVisits: ApexOptions;
    chartVisitorsVsPageViews: ApexOptions;
    chartNewVsReturning: ApexOptions;
    chartGender: ApexOptions;
    chartAge: ApexOptions;
    chartLanguage: ApexOptions;
    data: any;

    bg200 = {
        orange: 'bg-orange-200',
        green: 'bg-green-200',
        red: 'bg-red-200',
        indigo: 'bg-indigo-200',
        sky: 'bg-sky-200',
        yellow: 'bg-yellow-200',
    };

    bg600 = {
        orange: 'text-orange-600',
        green: 'text-green-600',
        red: 'text-red-600',
        indigo: 'text-indigo-600',
        sky: 'text-sky-600',
        yellow: 'text-yellow-600',
    };

    border600 = {
        orange: 'hover:border-orange-600',
        green: 'hover:border-green-200',
        red: 'hover:border-red-200',
        indigo: 'hover:border-indigo-600',
        sky: 'hover:border-sky-600',
        yellow: 'hover:border-yellow-600',
    };

    constructor() {}

    ngOnInit(): void {}
}
